import * as React from "react";
import ReactLazyLoad from "react-lazyload";
import { imageSourceGenerator } from "./image";
import { QNProps as QNParams } from "@ezbuy/smartimagesrc/lib/ImageSrcHandlers/Handler";
import { runInBrowser } from "utils/browser";
interface Status {
	originSrc: string;
	currentSrc: string;
}
export interface SmartImageProps {
	/** 是否为测试环境 测试环境和生产使用的 CDN 域名不同 仅对 ezbuy 有效 */
	online?: boolean;
	qnParams?: QNParams;
	isLazyLoad?: boolean;
	src: string;
	placeholder?: string;
	fallbackSrc?: string | false;
	// aliSize: 1, 2, 3... => 100px, 200px, 300px...，图片只能是正方形
	aliSize?: number;
	keepSize?: boolean;
	imgClass?: string;
	linkClass?: string;
	link?: string;
	style?: any;
	title?: string;
	alt?: string;
	blankLink?: boolean;
	/** 是否启用object-fit: cover */
	fit?: boolean;
	/** 加载完毕 无论最终结果是成功或者失败 */
	onFinish?: (status: Status) => void;
}

interface ImageState {
	useOriginSrc: boolean;
	imageSrc: string;
}

const dataImageRegex = /^data:image/;

export class SmartImage extends React.Component<SmartImageProps, ImageState> {
	static defaultProps = {
		online: true,
		className: "",
		isLazyLoad: false,
		alisize: 0,
		placeholder: `https://d3hp955ol7sp5f.cloudfront.net/newhome/placeholder/ezbuy_cart_200x200.png`,
		blankLink: false,
	};
	get imageProps() {
		const { qnParams, aliSize, online, keepSize } = this.props;
		return {
			qnParams,
			aliSize,
			keepSize: !!keepSize,
			online: !!online,
		};
	}

	get fallbackSrc() {
		return this.props.fallbackSrc;
	}

	state: ImageState = {
		useOriginSrc: false,
		imageSrc: "",
	};

	imageSourceGenerator: any = imageSourceGenerator(
		this.props.src,
		this.imageProps,
		this.fallbackSrc,
	);

	componentWillReceiveProps(nextProps: SmartImageProps) {
		if (this.props.src !== nextProps.src) {
			this.imageSourceGenerator = imageSourceGenerator(
				nextProps.src,
				this.imageProps,
				this.fallbackSrc,
			);
			this.updateImageSrc(nextProps);
		}
	}

	componentDidMount() {
		this.updateImageSrc();
	}

	updateImageSrc = (props = this.props) => {
		const { src } = props;

		if (!src || !runInBrowser()) {
			return;
		}

		if (dataImageRegex.test(src)) {
			return this.setState({ imageSrc: src });
		}

		const r = this.imageSourceGenerator.next();
		this.setState(
			{
				useOriginSrc: r.done,
				imageSrc: r.value,
			},
			() => r.done && this.finish(),
		);
	};

	finish() {
		const { onFinish, src } = this.props;
		if (typeof onFinish === "function") {
			onFinish({
				originSrc: src,
				currentSrc: this.state.imageSrc,
			});
		}
	}

	onImageLoad = (event: any) => {
		try {
			if (event.target.naturalWidth <= 1) {
				return this.onImageFailedLoad();
			}
			this.finish();
		} catch (err) {}
	};

	onImageFailedLoad = () => {
		if (!this.state.useOriginSrc) {
			this.updateImageSrc();
		}
	};

	render() {
		let {
			isLazyLoad,
			placeholder,
			imgClass,
			style = {},
			link,
			linkClass,
			title,
			alt,
			blankLink,
			fit,
			src,
		} = this.props;

		src = this.state.imageSrc || src;
		let fitStyle = fit ? { objectFit: "cover", height: "100%", width: "100%" } : {};
		style = { ...fitStyle, ...style };
		let imgProps = {
			className: imgClass,
			style,
			title,
			alt,
		};
		const placeholderEle = <img src={placeholder} {...imgProps} />;
		const aProps = link && blankLink ? { target: "_blank" } : {};
		if (!src) {
			return link ? (
				<a href={link} className={linkClass} {...aProps}>
					<img src={placeholder} {...imgProps} />
				</a>
			) : (
				<img src={placeholder} {...imgProps} />
			);
		}

		let height;
		let width;
		if (style) {
			height = style.height;
			width = style.width;
		}

		let ele;
		if (isLazyLoad) {
			ele = (
				<ReactLazyLoad height={height} placeholder={placeholderEle}>
					<img
						onLoad={this.onImageLoad}
						onError={this.onImageFailedLoad}
						src={src}
						{...imgProps}
						data-load-type="lazy"
					/>
				</ReactLazyLoad>
			);
		} else {
			ele = (
				<img
					src={src}
					onLoad={this.onImageLoad}
					onError={this.onImageFailedLoad}
					{...imgProps}
					width={width}
					height={height}
					data-load-type="normal"
					style={{ ...style }}
				/>
			);
		}

		if (link) {
			return (
				<a href={link} className={linkClass}>
					{ele}
				</a>
			);
		}
		return ele;
	}
}

export default SmartImage;
